import { applyColumnOrder, buildIndicators, hasActiveFilters, countActiveFacets } from '@/utils/controlTower'

export default {
  /**
   * Columnas del tablero con el orden del usuario ya aplicado (fijadas a la
   * izquierda, mandadas al final a la derecha, intercambios respetados).
   */
  orderedColumns (state) {
    return applyColumnOrder(state.board.columns, state.columnPreferences)
  },

  /**
   * Columnas visibles: si el usuario hizo clic en un indicador, solo esa.
   */
  visibleColumns () {
    const columns = this.orderedColumns
    if (!this.focusedColumnKey) return columns

    return columns.filter(column => String(column.key) === String(this.focusedColumnKey))
  },

  indicators (state) {
    const summary = state.layout === 'list' ? state.list.summary : state.board.summary
    return buildIndicators(summary, state.viewType, state.layout)
  },

  summary (state) {
    return (state.layout === 'list' ? state.list.summary : state.board.summary) || null
  },

  isLoading (state) {
    return state.status === 'loading'
  },

  isIdle (state) {
    return state.status === 'idle'
  },

  isEmpty (state) {
    return state.status === 'empty'
  },

  hasError (state) {
    return state.status === 'error'
  },

  hasFilters (state) {
    return hasActiveFilters(state.filters)
  },

  activeFacetCount (state) {
    return countActiveFacets(state.filters)
  },

  selectedCount (state) {
    return state.selection.ids.length
  },

  hasSelection (state) {
    return state.selection.active && state.selection.ids.length > 0
  },

  /**
   * Tareas seleccionadas, buscadas en la vista que esté activa.
   */
  selectedTasks (state) {
    const ids = new Set(state.selection.ids)
    if (state.layout === 'list') {
      return state.list.rows.filter(task => ids.has(task.id))
    }

    return state.board.columns
      .flatMap(column => column.tasks || [])
      .filter(task => ids.has(task.id))
  }
}
